var map = {
	"./en/agGrid.js": "9572",
	"./en/apiData.js": "9572",
	"./en/feishuSidebar.js": "9572",
	"./en/index.js": "9572",
	"./en/org.js": "9572",
	"./en/sso.js": "9572",
	"./en/website.js": "9572",
	"./zh/agGrid.js": "9572",
	"./zh/apiData.js": "9572",
	"./zh/feishuSidebar.js": "9572",
	"./zh/home.js": "9572",
	"./zh/index.js": "9572",
	"./zh/kanban.js": "9572",
	"./zh/master.js": "9572",
	"./zh/operationPlatform.js": "9572",
	"./zh/org.js": "9572",
	"./zh/sso.js": "9572",
	"./zh/website.js": "9572"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9d61";